import { Box, Button, Flex, Video } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Textarea from "components/landing/textarea"
import fetchPrices from "hoc/fetch-prices"

import DiamondItem from "./diamond-item"

const DiamondBlock = ({ data, prices }) => (
  <Box contain mb={4} py={3}>
    <Textarea element={data.texts} />

    <Video
      poster={require(`images/landings/diamond_stud_earrings/videos/${data.video.thumb}.jpg`)}
      style={{
        margin: "auto",
        pb: { _: 1, tablet: 2 },
        width: { _: "60%", tablet: "240px" },
      }}
      video={`${sl.config.jewlr_asset_url}videos/2021-diamond-studs/${data.video.name}.mp4`}
    />
    <Flex
      flexWrap={{ _: "wrap", tablet: "nowrap" }}
      gutter={2}
      mb={{ _: 2, tablet: 4 }}
      mx="auto"
      width={{ _: "82%", desktop: "65%", tablet: "80%" }}
    >
      {data.details.map(({ image, style_code }, i) => (
        <DiamondItem image={image} key={i} prices={prices[style_code]} />
      ))}
    </Flex>
    <Button
      as={Link}
      data-lc="diamond-block"
      outline="black"
      style={{ fontSize: { _: 14, desktop: 16 }, padding: "8px 48px" }}
      to="/diamond-stud-earrings"
    >
      Shop All
    </Button>
  </Box>
)

DiamondBlock.propTypes = {
  data: PropTypes.object,
  prices: PropTypes.object,
}

export default fetchPrices(DiamondBlock)
